import * as competitionApi from '../../api/competition'
import * as fundMapApi from '../../api/fundMap'
import { competitionTypes } from '../../constants/competitionTypes'
import _ from 'lodash'

async function getCompetitions({ commit }, getParams) {
  const { matchingCompetitions, isCompanyUnderTermination } = await competitionApi.getCompetitions(getParams)
  commit('setCompetitions', matchingCompetitions)
  commit('setIsCompanyUnderTermination', isCompanyUnderTermination)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Pályázatok adatainak betöltése sikeres.' } })
}

async function getCompetitionsSoleProprietorship({ commit }, getParams) {
  const { matchingCompetitions } = await competitionApi.getCompetitionsSoleProprietorship(getParams)
  commit('setCompetitions', matchingCompetitions)
  commit('setIsCompanyUnderTermination', false)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Pályázatok adatainak betöltése sikeres.' } })
}

async function getCompetitionsFundMap({ commit }, getParams) {
  const { matchingCompetitions, isCompanyUnderTermination } = await fundMapApi.getCompetitions(getParams)
  commit('setCompetitions', matchingCompetitions)
  commit('setIsCompanyUnderTermination', isCompanyUnderTermination)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Pályázatok adatainak betöltése sikeres.' } })
}

async function getCompetitionCounts({ commit }, getParams) {
  const { isCompanyUnderTermination, ...competitionCounts } = await competitionApi.getCompetitionCounts(getParams)
  commit('setCompetitionCounts', competitionCounts)
  commit('setIsCompanyUnderTermination', isCompanyUnderTermination)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Pályázatok adatainak betöltése sikeres.' } })
}

async function getCompetitionCountsSoleProprietorship({ commit }, getParams) {
  const {
    isCompanyUnderTermination,
    ...competitionCounts
  } = await competitionApi.getCompetitionCountsSoleProprietorship(getParams)
  commit('setCompetitionCounts', competitionCounts)
  commit('setIsCompanyUnderTermination', isCompanyUnderTermination)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Pályázatok adatainak betöltése sikeres.' } })
}

async function getSelectedCompetitions({ commit }, getParams) {
  const { competitions } = await competitionApi.getSelectedCompetitions(getParams)

  const competitionsPrefix = competitions.map(competition => {
    const prefixHttp = 'http://'
    const prefixHttps = 'https://'
    if (
      competition.link.substr(0, prefixHttp.length) !== prefixHttp &&
      competition.link.substr(0, prefixHttps.length) !== prefixHttps
    ) {
      competition.link = prefixHttps + competition.link
    }
    return {
      ...competition
    }
  })

  commit('setSelectedCompetitions', competitionsPrefix)
  commit(
    'setselectedCredits',
    competitionsPrefix.filter(c => c.type === competitionTypes.CREDIT)
  )
  commit(
    'selectedCapitalProducts',
    competitionsPrefix.filter(c => c.type === competitionTypes.CAPITAL_PRODUCT)
  )
  commit(
    'selectedGuarantees',
    competitionsPrefix.filter(c => c.type === competitionTypes.GUARANTEE)
  )
}

function setCompetitions(state, competitions) {
  state.competitions = competitions
}
function setCompetitionCounts(state, competitionCounts) {
  state.competitionCounts = competitionCounts
}
function setSelectedCompetitions(state, competitions) {
  state.selectedCompetitions = competitions
}
function setselectedCredits(state, competitions) {
  state.selectedCredits = competitions
}
function selectedCapitalProducts(state, competitions) {
  state.selectedCapitalProducts = competitions
}
function selectedGuarantees(state, competitions) {
  state.selectedGuarantees = competitions
}

function setIsCompanyUnderTermination(state, isCompanyUnderTermination) {
  state.isCompanyUnderTermination = isCompanyUnderTermination
}

const companyCompetitionStore = {
  state: {
    competitions: [],
    competitionCounts: {},
    isCompanyUnderTermination: false,
    selectedCompetitions: [],
    selectedCredits: [],
    selectedCapitalProducts: [],
    selectedGuarantees: []
  },
  actions: {
    getCompetitions,
    getCompetitionsSoleProprietorship,
    getCompetitionsFundMap,
    getCompetitionCounts,
    getCompetitionCountsSoleProprietorship,
    getSelectedCompetitions
  },
  mutations: {
    setCompetitions,
    setCompetitionCounts,
    setSelectedCompetitions,
    setselectedCredits,
    selectedCapitalProducts,
    selectedGuarantees,
    setIsCompanyUnderTermination
  },
  getters: {
    competitions: state => {
      return state.competitions
    },
    applicationCount: state => {
      return state.competitionCounts.applicationCount
    },
    creditCount: state => {
      return state.competitionCounts.creditCount
    },
    guaranteeCount: state => {
      return state.competitionCounts.guaranteeCount
    },
    capitalProductCount: state => {
      return state.competitionCounts.capitalProductCount
    },
    totalCount: state => {
      return state.competitionCounts.totalCount
    },
    competitionApplications: state => {
      return _.sortBy(
        state.competitions.filter(competition => competition.type === competitionTypes.APPLICATION),
        a => a.name.toLowerCase()
      )
    },
    competitionGuarantees: state => {
      return _.sortBy(
        state.competitions.filter(competition => competition.type === competitionTypes.GUARANTEE),
        a => a.name.toLowerCase()
      )
    },
    competitionCapitalProducts: state => {
      return _.sortBy(
        state.competitions.filter(competition => competition.type === competitionTypes.CAPITAL_PRODUCT),
        a => a.name.toLowerCase()
      )
    },
    competitionCredits: state => {
      return _.sortBy(
        state.competitions.filter(competition => competition.type === competitionTypes.CREDIT),
        a => a.name.toLowerCase()
      )
    },
    companyUnderTermination: state => {
      return state.isCompanyUnderTermination
    },
    selectedCompetitions: state => {
      return state.selectedCompetitions
    },
    selectedCredits: state => {
      return state.selectedCredits
    },
    selectedCapitalProducts: state => {
      return state.selectedCapitalProducts
    },
    selectedGuarantees: state => {
      return state.selectedGuarantees
    }
  }
}

export default companyCompetitionStore
